import { render, staticRenderFns } from "./WorkloadDetailEndpoints.vue?vue&type=template&id=c1c52692&scoped=true&"
import script from "./WorkloadDetailEndpoints.vue?vue&type=script&lang=js&"
export * from "./WorkloadDetailEndpoints.vue?vue&type=script&lang=js&"
import style0 from "./WorkloadDetailEndpoints.vue?vue&type=style&index=0&id=c1c52692&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c52692",
  null
  
)

export default component.exports